import callAPiBase from './base';

const messagesApi = {
  // v2: paginated history. `cursor` is the previous page's nextCursor and
  // contains '#', so the query string must be encoded.
  get: ({
    Room,
    limit,
    cursor,
  }: {
    Room: string;
    limit?: number;
    cursor?: string;
  }) => {
    const params = new URLSearchParams({ Room });

    if (limit) {
      params.append('limit', String(limit));
    }

    if (cursor) {
      params.append('cursor', cursor);
    }

    return callAPiBase({
      endpoint: `/api/messages/user?${params.toString()}`,
      method: 'GET',
      useToken: true,
    });
  },
};

export { messagesApi };
export default messagesApi;
